import(/* webpackMode: "eager", webpackExports: ["ProductList"] */ "/workspace/src/app/ProductList.tsx");
